import styled from 'styled-components';
import theme from '../../styles/theme';

export const InstrumentationActionButtonContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const ClickMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${theme.colors.neutral.bg.inverted};
  border: 1px solid ${theme.colors.neutral.border.weak};
  border-radius: ${theme.borderRadius['border-radius-3']};
  box-shadow: ${theme.elevations['elevation-2']};
  z-index: 1000;
  margin-top: 4px;
  overflow: hidden;
`;

export const MenuItem = styled.div`
  padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-4']};
  cursor: pointer;
  font-size: 14px;
  color: ${theme.colors.neutral.text.strong};
  border-bottom: 1px solid ${theme.colors.neutral.border.weak};
  transition: background-color 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${theme.colors.neutral.bg.regular};
  }
`;
